import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Spinner } from "react-bootstrap";
import ProfileLocalizeMe from "./ProfileLocalizeMe";
import ParametersStamp from "./ParametresStamp";
import ProfilAnnexes from "./ProfilAnnexes";
import ProfileSaveLayers from "./ProfileSaveLayers";
import ProfilAddress from "./ProfilAddress";

const Parameters = (props) => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {}, []);

    return (
        <div
            id={"parameters_page"}
            className={"container-fluid  text-dark  w-100 h-100 "}
        >
            <div className={"row h-100"}>
                <div
                    className={"col-12 col-lg-6"}
                    style={{ backgroundColor: "#f1f4f4" }}
                >
                    <div
                        className={
                            "d-flex flex-column justify-content-start align-content-start w-100 h-100 rounded "
                        }
                    >
                        <ProfileSaveLayers />
                        {isLoading ? (
                            <div className="row vh-100">
                                <div className="col-12 justify-content-center align-items-center">
                                    <div className="text-center my-2 ">
                                        <Spinner
                                            animation="border"
                                            size={"sm"}
                                        />
                                    </div>
                                </div>
                            </div>
                        ) : props?.entity?.genre?.slug === "collective" ? (
                            <ProfilAnnexes />
                        ) : (
                            <div className="d-flex flex-column w-100">
                                <div className="accordion" id="accordionAnnexes">
                                    <div className={"ue-annexes-section"}>
                                        <ProfilAddress />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className={"col-12 col-lg-6 h-100 "}>
                    <div
                        className={
                            "d-flex flex-column justify-content-start align-content-start w-100 h-100 bg-white p-4"
                        }
                    >
                        {/* <h6 className={"my-3 font-weight-bold"}>
                            Position au démmarage
                        </h6> */}
                        <ProfileLocalizeMe />
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        userId: state.MeReducer.id,
        username: state.MeReducer.username,
        role: state.MeReducer.role,
        uiTheme: state.AppReducer.ui_theme,
        userPrefs: state.MeReducer?.prefs,
        structureInfo: state.SubscribtionReducer.structureInfo,
        entity: state.MeReducer.entity,
    };
};

const mapDispatchTProps = (dispatch) => {
    return {
        updateUserInfo: (e) =>
            dispatch({ type: "UPDATE_USER_STATUS", data: e }),
    };
};

export default connect(mapStateToProps, mapDispatchTProps)(Parameters);
